<template>
  <zen-one
    :showuserinfo="false"
    :crumbs="crumbs"
    title="Sistem Hasil Bersepadu Kedah (iHasil)"
  >

    <z-page title="Butiran : Kewangan 38">

        <div class="message-box">
          <w-transition-fade>
            <w-alert
              class="my0 text-light"
              v-if="form.submitted"
              success
              no-border>
              The form is valid, ready to send it!
            </w-alert>

            <w-alert
              class="my0 text-light"
              v-else-if="form.valid === false"
              error
              no-border>
              Terdapat {{ form.errorsCount }} ralat di dalam borang ini.
            </w-alert>
          </w-transition-fade>
        </div>

    <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess" >

                <w-flex justify-center align-center>
                    <div class="xs3">
                          <h5 class="fw-semibold m0">
                              Tarikh Bayaran :
                          </h5>
                          <div class="fw-normal my1 fs-1">{{$zutil.dateformat(form.created_at)}}</div>
                    </div>
                    <div class="xs3">
                          <h5 class="fw-semibold m0">
                              Cara Bayaran :
                          </h5>
                          <div class="fw-normal my1 fs-1">{{form.cara_bayaran_keterangan}}</div>
                    </div>
                    <div class="xs3">
                          <h5 class="fw-semibold m0">
                              No. Penyata Pemungut :
                          </h5>
                          <div class="fw-normal my1 fs-1">{{form.no_penyata_pemungut}} </div>
                    </div>
                    <div class="xs3">
                          <h5 class="fw-semibold m0">
                              No. Rujukan Bank :
                          </h5>
                          <div class="fw-normal my1 fs-1">{{form.no_slip_bank}} </div>
                    </div>
                </w-flex>

             <w-flex justify-center align-center class="table-hardcode">
                <div class="w-card__content content-hardcode mt3">
                  <table class="table-dashboard" width="100%" >
                    <thead>
                        <tr>
                            <td>Jabatan</td>
                            <td>No. Rujukan</td>
                            <td>Nama</td>
                            <td>Kod Akaun</td>
                            <td>Butiran Bayaran</td>
                            <!-- <td>Amaun (RM)</td> -->
                            <td>Amaun Bayar (RM)</td>
                            <td>No. Resit Kew. 38</td>
                            <td>Catatan</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{form.jabatan_keterangan}}</td>
                            <td>{{form.number_rujukan}}</td>
                            <td>{{form.user_keterangan}}</td>
                            <td>{{form.akaun_keterangan}}</td>
                            <td>{{form.akaun_keterangan}}</td>
                            <!-- <td></td> -->
                            <td>{{form.amaun}}</td>
                            <td>{{form.no_resit}}</td>
                            <td>{{form.catatan}}</td>
                        </tr>
                    </tbody>
                </table>
              </div>
        </w-flex>
     </w-form>
    </z-page>
  </zen-one>
</template>

<script>

import ZResource from '@/Modules/z-resource-service'

export default {
extends: ZResource,
components: {
},
props: {
    items: [Array, Object],
    id: [Array, Object, String],
},
data() {
    return {

  resourceurl:  this.service_kutipan+'penyata_pemungut',

  form: {
    valid: null,
    submitted: false,
    sent: false,
    errorsCount: 0,
    nama: '',
    no_id: '',
    status_mel: '',
    data_bayaran: []
  },
  crumbs: [
        { label: 'iHasil', route: '/' },
        { label: 'Kutipan', route: '/kutipan' },
        { label: 'Kewangan 38', route: '/kutipan/kew38' },
        { label: 'Papar', route: '/bayaran/1' },
  ],
  showCard: false,
  data_bayaran: []
}},
methods: {

  onSuccess () {
    setTimeout(() => (this.form.sent = true), 2000)
    // this.$inertia.visit(window.route('kutipan.mel.index'));
    this.$inertia.visit(this.$page.url)
  },
  onValidate () {
    this.form.sent = false
    this.form.submitted = this.form.errorsCount === 0
  },
  submitPenyataPemungut() {
        this.$zcomm.get(this.service_kutipan+'terimaan'+'?no_rujukan='+this.form_cari.no_rujukan).then(res => {
        //   console.log(res.data)
            if (res.data.butiran) {
                this.form.inbois_id = res.data.id;
                this.form.butiran = res.data.butiran;
                this.form.amaun = res.data.amaun;
                this.form.no_inbois = res.data.no_inbois;
                this.form.jabatan_id = res.data.jabatan.id;
            }else{
                this.form.hm_akaun_id = res.data.id;
                this.form.hm_cukai = res.data.hm_cukai;
                this.form.keluasan = res.data.keluasan;
                this.form.no_hm = res.data.no_hm;
                this.form.jabatan_id = res.data.jabatan.id;
            }

        });
    },
},
watch: {


},
mounted() {

},
}

</script>

<style>


</style>
